module.exports = __webpack_public_path__ + "static/media/JH_web_7.e9ad593f.jpg";